export default __webpack_public_path__ + "static/media/Icon=Legacy.8136ea3e.svg";